import { Injectable, Inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { MaintService, AuthService } from '../service';

@Injectable({
  providedIn: 'root'
})
export class GetPodStatusResolver implements Resolve<any> {
    constructor(
        @Inject(MaintService) public maintService: MaintService) { }

    resolve() {
        return this.maintService.getPodStatus();
    }
}
